import React from "react";
import { inject, observer } from "mobx-react";

import { Grid } from "@material-ui/core";

import { IManagementStore } from "Stores/Management/types";

import TableSearchInput from "@src/Components/Common/TableSearchInput/TableSearchInput";
import filterByTableColumns from "@src/Tools/filterByTableColumns";
import { observable, computed } from "mobx";

import ResultsAreEmpty from "@src/Components/Ui/ResultsAreEmpty";
import STPageHeader from "@src/Components/Ui/STPageHeader";
import { Values } from "@src/Tools/Values";
import AddTheme from "./AddTheme/AddTheme";
import ThemesTable from "./ThemesTable/ThemesTable";
import { Theme } from "@src/Interfaces/Entity/Theme";
import { IAuthStore } from "@src/Stores/Auth/types";

interface IProps {
  management?: IManagementStore;
  auth?: IAuthStore;
}

@inject("auth", "management")
@observer
class ThemesContent extends React.Component<IProps> {
  @observable searchText: string = "";

  @computed get filteredThemes() {
    return filterByTableColumns<Theme>(
      this.props.management.themes,
      this.searchText
    );
  }

  handleChange = (event: any) => {
    this.searchText = event.target.value;
  };

  render() {
    return (
      <Grid container direction="column">
        <STPageHeader>{Values.getLocalizationValue("themes")}</STPageHeader>
        <Grid container justify="space-between" alignItems="center" item>
          <Grid item>
            <TableSearchInput
              value={this.searchText}
              onChange={this.handleChange}
            />
          </Grid>
          <AddTheme />
        </Grid>
        <Grid item xs>
          {this.filteredThemes.length > 0 ? (
            <ThemesTable themes={this.filteredThemes} />
          ) : (
            <ResultsAreEmpty />
          )}
        </Grid>
      </Grid>
    );
  }
}

export default ThemesContent;
